import { pgTable, uuid, text, boolean, jsonb, timestamp } from "drizzle-orm/pg-core";

export const courierSettings = pgTable("courier_settings", {
  id: uuid("id").primaryKey().defaultRandom(),
  provider: text("provider").notNull().unique().$type<"dpd" | "omniva" | "venipak">(),
  active: boolean("active").notNull().default(false),
  displayName: text("display_name").notNull(),
  config: jsonb("config").notNull().default({}),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export type CourierSetting = typeof courierSettings.$inferSelect;
export type NewCourierSetting = typeof courierSettings.$inferInsert;
